import React from 'react';
import { useHistory } from 'react-router-dom';

type props = {
  heading: header[];
  position: number;
  optionalButton?: React.ReactNode;
  isDisabled?: any;
  isDataModified?: any;
  forwardParams?: boolean;
  setPosition?: any;
};

interface header {
  path: string;
  heading: string;
}

const SwitchBar: React.FunctionComponent<props> = ({
  heading,
  position,
  optionalButton,
  isDisabled,
  forwardParams = false,
  setPosition = undefined,
}): JSX.Element => {
  const history = useHistory();

  return (
    <div className="gray-border-line bg-gray-background-light flex h-10 w-full items-center justify-between border-b px-4">
      <div className="gray-background-dark flex h-full items-center justify-center">
        {heading.map((item: any, index) => (
          <button
            className={`px-5 py-2 text-sm ${index === position ? 'bg-blue-primary h-full font-bold text-white' : 'text-gray-dark h-full'} ${isDisabled ? 'cursor-not-allowed' : ''} `}
            onClick={() => {
              history.push(forwardParams ? item.path.toString() + '/' + window.location.search : item.path.toString());
              setPosition && setPosition(index);
            }}
            disabled={isDisabled}
            data-testid={`header-tab-${item.heading}`}
          >
            {item.heading}
          </button>
        ))}
      </div>
      {optionalButton}
    </div>
  );
};

export default SwitchBar;
